import { FC, Fragment, useEffect, useState } from 'react';
import Button from 'components/ui/Button/Button';
import { loadAnalytics } from 'services/cms';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

interface CookiePolicyProps {
  policyLink?: string;
  onAccept?: () => void;
}

const CookiePolicy: FC<CookiePolicyProps> = ({ policyLink, ...props }) => {
  const [isShown, setIsShown] = useState(false);
  const { t } = useTranslation();
  const { pathname } = useLocation();

  useEffect(() => {
    const result = localStorage.getItem('cookie-policy-result');
    if (!result) {
      setIsShown(true);
    } else if (result === 'accepted') {
      setTimeout(() => {
        loadAnalytics();
        props.onAccept?.();
      }, 1000);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onAccept = () => {
    localStorage.setItem('cookie-policy-result', 'accepted');
    setIsShown(false);
    props.onAccept?.();
    loadAnalytics();
  };

  const onReject = () => {
    localStorage.setItem('cookie-policy-result', 'rejected');
    setIsShown(false);
  };

  if (pathname.includes('proposal/preview')) {
    return null;
  }

  return (
    <Fragment>
      {isShown && (
        <div className="cookie-policy">
          <div className="title">{t('cookie.title')}</div>

          <div className="cookie-policy-content">
            <span className="text-lh">
              {t('cookie.text')}
              <a href={policyLink || '/pages/privacy'} target="_blank" rel="noreferrer">
                {t('cookie.cookie_policy')}
              </a>
            </span>
            <div className="cookie-policy-buttons ">
              <Button
                title={t('cookie.reject')}
                className="btn btn-default mr-10"
                onClick={onReject}
              />
              <Button title={t('cookie.accept')} className="btn btn-primary " onClick={onAccept} />
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default CookiePolicy;
